import 'element-plus/dist/index.css'
import './assets/main.css'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import * as Sentry from '@sentry/vue'
import { plugin as unleashPlugin } from '@unleash/proxy-client-vue'
import ElementPlus from 'element-plus'
import { createPinia } from 'pinia'
import { createApp, type Plugin } from 'vue'
import VueVirtualScroller from 'vue-virtual-scroller'

import App from '@/App.vue'
import { config, initializeProviders } from '@/lib/helpers'
import { errorHandlerPlugins, unleashClient } from '@/lib/plugins'
import { router } from '@/router'

const app = createApp(App)

app.use(createPinia())
app.use(ElementPlus)
app.use(router)
app.use(unleashPlugin as unknown as Plugin, {
  unleashClient,
  startClient: true,
})
app.use(errorHandlerPlugins)
app.use(VueVirtualScroller)

if (config.environment !== 'local') {
  Sentry.init({
    app,
    dsn: config.sentryDsn,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    environment: config.environment,
  })
}

initializeProviders(app)
app.mount('#app')
